module.exports = __webpack_public_path__ + "static/media/FranchiseImage1.066e47b6.png";